import { jsx, jsxs } from 'react/jsx-runtime';
import { IconChevronRightSolid } from '@circlefin/euclid-icons/common';
import classNames from 'classnames';
import { Menu } from '../../Menu/Menu.es.js';
import { StackedListCell } from '../StackedList.Cell/StackedList.Cell.es.js';

const StackedListItem = ({ onClick, className, children })=>{
    const cells = children.filter((c)=>c.type === StackedListCell);
    const menu = children.find((c)=>c.type === Menu);
    return jsx("li", {
        "data-testid": "item",
        children: jsxs("div", {
            className: classNames('cb-stacked-list-item', className),
            children: [
                jsx("div", {
                    className: "grid min-w-0 flex-1 grid-cols-3 items-center",
                    children: cells
                }),
                jsx("div", {
                    className: classNames('w-4', menu && 'h-5'),
                    children: menu || onClick && jsx(IconChevronRightSolid, {
                        className: "text-neutral-subtlest",
                        onClick: onClick,
                        size: 20
                    })
                })
            ]
        })
    });
};
StackedListItem.displayName = 'StackedList.Item';

export { StackedListItem };
//# sourceMappingURL=StackedList.Item.es.js.map
